/* Author:

*/
// Global Variables


var isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);

(function($) {

	'use strict';

	function headerSearchInit() {
		$('.header-search-bar .search-input').on('focus', function() {
			$('.header-search-bar').addClass('active');
		});
		$('.header-search-bar .search-input').on('blur', function() {
			$('.header-search-bar').removeClass('active');
		});
	}


	function megaDropdownInit() {
		
		var $header = $('.header');
		var $megaDropdown = $('.mega-dropdown');
		var $megaTrigger = $('.mega-trigger');

		var tallestInit = function() {
			var tallest = -1;
			$('.submenu').each(function() {
				var $this = $(this);
				var $submenuList = $(this).find('.submenu-list');
				if ($submenuList.height() > tallest) {
					tallest = $submenuList.height();
				}
			});
			console.log(tallest);
			$megaDropdown.height(tallest);
		};


		tallestInit();

		$('.navbar').on('mouseenter', function() {
			$header.addClass('menu-show').outerWidth();
			$header.addClass('menu-animate');
		});

		$('.topbar').on('mouseenter', function() {
			$header.removeClass('menu-animate').one('transitionend webkit', function() {
				$header.removeClass('menu-show');
			});
		});

		$('.mega-dropdown').on('mouseleave', function(event) {
			$header.removeClass('menu-animate').one('transitionend webkit', function() {
				$header.removeClass('menu-show');
			});
		});


	}



	function equalizer() {
		var equalheight = function(container){

		var currentTallest = 0,
		     currentRowStart = 0,
		     rowDivs = [],
		     $el,
		     topPosition = 0;
		 $(container).each(function() {

		   $el = $(this);
		   $($el).height('auto');
		   topPostion = $el.position().top;

		   if (currentRowStart != topPostion) {
		     for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
		       rowDivs[currentDiv].height(currentTallest);
		     }
		     rowDivs.length = 0; // empty the array
		     currentRowStart = topPostion;
		     currentTallest = $el.height();
		     rowDivs.push($el);
		   } else {
		     rowDivs.push($el);
		     currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
		  }
		   for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
		     rowDivs[currentDiv].height(currentTallest);
		   }
		 });
		};

		var block = function(element) {
			$(element).each(function() {
				var $this = $(this);
				var eh = $this.find('.equal-height');
				equalheight(eh);
			});
		};

		$(window).load(function() {
		  	block('.block-equal-height');
		});

		$(window).resize(function(){
		  	block('.block-equal-height');
		});
	}



	function accordionInit() {
		

		// Horizontal Accordion - Featured Services

		$('.h-acc').each(function() {
			var $this = $(this);
			var $trigger = $this.find('.acc-content');
			var $services = $('.services-content-inner');
			$trigger.on('click', function(event) {
				event.preventDefault();
				var index = $(this).index();
				console.log(index);
				$('.acc-content').removeClass('active');
				$('.services-content-inner').removeClass('fade-in');
				$('.services-content-inner').removeClass('active');
				$services.eq(index).addClass('active').outerWidth();
				$services.eq(index).addClass('fade-in');
				$(this).addClass('active');
			});	
		});
	}


	// Google Map
	//---------------------------------------------------------//

	function initialize() {
		var centerMap = new google.maps.LatLng(49.284449, -123.119348);

		var styles = [
			{
				"stylers": [
					{
						"saturation": -100
					}
				]
			}
		];

		var mapProp = {
			center: centerMap,
			zoom: 18,
			scrollwheel: false,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			styles: styles,
			// Disable all controls
			// disableDefaultUI: true,
			// Or selectively disable controls
			// zoomControl: false,
			mapTypeControl: false,
			// scaleControl: false,
			streetViewControl: false,
			// rotateControl: false,
			// fullscreenControl: false
		};
		
		var map = new google.maps.Map(document.getElementById("map-contact"), mapProp);

		// Define icon configurations
		var icons = {
			subIcon: {
				url: 'https://cdn.shopify.com/s/files/1/2457/3259/files/map-wheel.png?14642468224406949987',
				title: 'Wheelchair Access'
			},
			mainIcon: {
				url: 'https://cdn.shopify.com/s/files/1/2457/3259/files/marker.png?11401987949834241265'
			}
		};

		// Define icon locations
		var iconPlaces = [
			{
				position: new google.maps.LatLng(49.284250, -123.120317),
				type: 'subIcon'
			},
			{
				position: new google.maps.LatLng(49.284449, -123.119348),
				type: 'mainIcon'
			}
		];

		// Create markers using AdvancedMarkerElement instead of Marker
		const markers = [];
		
		// Use standard Marker - we'll upgrade in a more comprehensive update
		iconPlaces.forEach(function(iconPlace) {
			const marker = new google.maps.Marker({
				position: iconPlace.position,
				icon: icons[iconPlace.type].url,
				map: map,
				title: icons[iconPlace.type].title || ''
			});
			markers.push(marker);
		});
		
		// We'll implement advanced marker content in a future update

		// Create an info window for displaying place details
		const infoWindow = new google.maps.InfoWindow();
		const placeId = 'ChIJ09HC74FxhlQRT3vKKcy2HGI';
		
		// Just use PlacesService since we're getting errors with Place API
		usePlacesServiceFallback();
		
		// Fallback function to use the legacy PlacesService
		function usePlacesServiceFallback() {
			var service = new google.maps.places.PlacesService(map);
			
			service.getDetails({
				placeId: placeId
			}, function(place, status) {
				if (status === google.maps.places.PlacesServiceStatus.OK) {
					// Add click listeners to markers
					markers.forEach(marker => {
						google.maps.event.addListener(marker, 'click', function() {
							infoWindow.setContent(
								'<div class="map-store"><strong>' + place.name + '</strong>' +
								'<br>' + '<div class="address">' + place.formatted_address + '</div>' + 
								'<a href="'+ place.url +'" target="_blank">' + 'View on Google Maps' + '</a>' + '</div>'
							);
							infoWindow.open(map, marker);
						});
					});
					
					// Close info window when clicking on map
					google.maps.event.addListener(map, 'click', function() {
						infoWindow.close();
					});
				}
			});
		}
	}

	if ($('#map-contact').length > 0) {
		// Add event listener for when the Google Maps API is loaded
		google.maps.event.addDomListener(window, 'load', initialize);
	}

		


	//============================
	$(document).ready(function() {
		FastClick.attach(document.body);
		headerSearchInit();
		megaDropdownInit();
		$('.match-height').matchHeight();
		equalizer();
		accordionInit();

		$('.template-product.ticket .product-single form .action-container a.btn.btn-back').click(function(){
			parent.history.back();
			return false;
		});
	});


	$(window).scroll(function() {
		var offset = $("main.main").offset();

		if ( $(this).scrollTop() > offset.top ){  
			$('header.header').addClass("sticky");
			$('html body').addClass("on-sticky");
		}
		else if ($(this).scrollTop() <= 150 ) {
			$('header.header').removeClass("sticky");
			$('html body').removeClass("on-sticky");
		}
	});

	let totalGroupTickets = 0;
	$('.group-admission-input').on('change', function() {
		totalGroupTickets = 0;
		$('.group-admission-input').each(function() {
			totalGroupTickets += parseInt($(this).val()) ? parseInt($(this).val()) : 0;
		});
		console.info('TOTAL: ', totalGroupTickets);
		if(totalGroupTickets > 0 && totalGroupTickets < 10) {
			$('#error-message').removeClass('hide');
			$('#AddToCart').prop('disabled', true);
			$('#AddToCart').addClass('disabled');
		}
		else {
			$('#error-message').addClass('hide');
			$('#AddToCart').removeClass('disabled');
			$('#AddToCart').prop('disabled', false);
		}
	});
	
})(jQuery);